import * as am4core from "@amcharts/amcharts4/core";

export const styleDateAxis = (dateAxis) => {
  const grey = "#808080";
  dateAxis.renderer.grid.template.location = 0;
  dateAxis.title.text = "[bold]Time[/]";
  dateAxis.dateFormats.setKey("hour", "h a");
  dateAxis.periodChangeDateFormats.setKey("hour", "h a");
  dateAxis.dateFormats.setKey("minute", "h:mm a");
  dateAxis.periodChangeDateFormats.setKey("minute", "h:mm a");
  dateAxis.fill = am4core.color(grey);
  dateAxis.title.fill = am4core.color(grey);
  dateAxis.renderer.labels.template.fill = am4core.color(grey);
};

export const styleValueAxis = (valueAxis) => {
  const grey = "#808080";
  valueAxis.renderer.minWidth = 35;
  valueAxis.title.fill = am4core.color(grey);
  valueAxis.renderer.labels.template.fill = am4core.color(grey);
};

export const styleLegend = (legend) => {
  legend.paddingLeft = 40;
  legend.paddingTop = 15;
  legend.labels.template.text = "[{color}]{name}";
  legend.labels.template.textDecoration = "none";
  legend.labels.template.fontSize = 13;
  legend.markers.template.width = 13;
  legend.markers.template.height = 13;
  legend.valueLabels.template.textDecoration = "none";
};



// WEBPACK FOOTER //
// ./resources/assets/js/app/utilities/Charts/styles.js